export const interpolations = pupInfo => ({
  pupName: pupInfo?.name,
  pupGender: pupInfo?.gender,
  pupPronounLowercase: pupInfo?.gender === 'Female' ? 'she' : 'he',
  pupPronounUppercase: pupInfo?.gender === 'Female' ? 'She' : 'He',
  pupPossessivePronoun: pupInfo?.gender === 'Female' ? 'her' : 'his',
  pupObjectivePronoun: pupInfo?.gender === 'Female' ? 'her' : 'him',
  pupStatusTermLowercase: pupInfo?.gender === 'Female' ? 'spayed' : 'neutered',
  pupStatusTermUppercase: pupInfo?.gender === 'Female' ? 'Spayed' : 'Neutered',
  pupStatusTermVerb: pupInfo?.gender === 'Female' ? 'spay' : 'neuter',
});
